// @flow

import React from "react";
import type { Node } from "react";
import className from "classnames";
import { Row, Col } from "reactstrap";
import { Button } from "../button";
import Column from "./subcomponents/column";
import SubColumns from "./subcomponents/subcolumns";
import SubRows from "./subcomponents/subrows";
import type { ButtonType, Rows } from "./types";
import "./columns-container.style.scss";

export type Props = {|
  className?: string,
  columnClassName?: string,
  title?: string,
  titleColor: string,
  titleButtons?: ButtonType[],
  centeredTitle: boolean,
  rows: Rows[],
  children?: Node,
|};

export const ColumnsContainer = (props: Props) => (
  <div className={className("columns-container", props.className)}>
    {/* Container title and title buttons */}
    <Row noGutters={true} className="mb-3 align-items-center">
      <Col>
        <h4
          className={className(`font-weight-bold text-${props.titleColor} mb-0`, {
            "text-center": props.centeredTitle,
          })}
        >
          {props.title || ""}
        </h4>
      </Col>
      {props.titleButtons && (
        <Col className="d-flex justify-content-end">
          {props.titleButtons.map(button => (
            <Button
              key={button.text}
              className={className("ml-2", button.className)}
              color={button.color}
              onClick={button.onClick}
            >
              {button.text}
            </Button>
          ))}
        </Col>
      )}
    </Row>

    {/* Creating main rows */}
    {props.rows.map((row, index) => (
      <Row key={`row-${index}`} noGutters={true} className="mb-4 columns-container-rows">
        {row.columns.map((column, index) => (
          <Col key={`col-${index}`}>
            {!column.subRows && !column.subColumns && (
              <Column column={column} className={props.columnClassName} />
            )}
            {/* if has subColumns in a column */}
            {column.subColumns && !column.subRows && <SubColumns column={column} />}
            {/* if has multiple subRows in one column */}
            {column.subRows && <SubRows rows={column.subRows} />}
          </Col>
        ))}
      </Row>
    ))}

    <div className="px-3">{props.children}</div>
  </div>
);

ColumnsContainer.defaultProps = {
  centeredTitle: false,
  titleColor: "black",
};

export default ColumnsContainer;
